// removed by extract-text-webpack-plugin
module.exports = {"container":"_1rGuEdJ1Sh3Xm1Is","container-open":"_1Xx2Al7iWdcq47VN"};


//////////////////
// WEBPACK FOOTER
// ./src/bundles/business_shopping_centers_serp/components/map_with_toggle/map_with_toggle.css
// module id = 727
// module chunks = 0